import React from 'react';
import { PhoneCall } from 'lucide-react';
import { usePhoneBar } from '@/contexts/PhoneBarContext';

export const StickyPhoneBar = () => {
  const { isVisible, phoneNumber } = usePhoneBar();

  if (!isVisible) return null;

  return (
    <div className={`fixed bottom-0 left-0 right-0 z-50 transform transition-transform duration-300 ease-in-out ${
      isVisible ? 'translate-y-0' : 'translate-y-full'
    }`}>
      <a
        href={`tel:${phoneNumber}`}
        className="flex items-center justify-center w-full bg-blue-800 hover:bg-blue-900 text-white py-4 px-4 transition-colors duration-200 shadow-lg"
        aria-label={`Call Safeway Roofing and Chimney at ${phoneNumber.replace('+1', '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')}`}
      >
        <PhoneCall className="w-6 h-6 mr-3 flex-shrink-0" />
        <span className="text-lg font-semibold">{phoneNumber.replace('+1', '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')}</span>
      </a>
    </div>
  );
};